import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // parameter: error
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // parameter: error, errorInfo
  componentDidCatch() {
    // You can also log the error to an error reporting service
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          height="100vh"
        >
          <Typography variant="h4" fontWeight="bold">
            Something went wrong
          </Typography>
          <Link to="/dashboard/app">Go to dashboard</Link>
        </Stack>
      );
      // return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default ErrorBoundary;
